export enum ShipFrequencyCode {
  Immediate = 0,
  EveryWeek = 1,
  Every2Weeks = 2,
  Every3Weeks = 3,
  WhenBinIsFull = 99
}
